import { render, staticRenderFns } from "./ReportMealsTabEmployeeItems.vue?vue&type=template&id=1f3f1918"
import script from "./ReportMealsTabEmployeeItems.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabEmployeeItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports